import { createSlice } from '@reduxjs/toolkit';
import { addMake, fetchMakes, removeMake, editMake } from '../actions/vehicleMakes-actions';
import { Status } from '../../helpers/consts/status';

const initialState = {
  isLoading: false,
  makes: [],
  count: 0,
};

const makesSlice = createSlice({
  name: 'vehicleMakes',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchMakes.pending, (state, action) => {
        state.status = Status.LOADING;
      })
      .addCase(fetchMakes.fulfilled, (state, action) => {
        const makes = action.payload;
        state.makes = makes;
        state.isLoading = false;
       // state.status = Status.COMPLETED;
      })
      .addCase(fetchMakes.rejected, (state, action) => {
        
      })
      .addCase(addMake.fulfilled, (state, action) => {
        const newMake = action.payload;
        state.makes.push(newMake);
      })
      .addCase(editMake.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.makes.findIndex((make) => make.id === data.id);
        if (~index) {
          state.makes[index] = data;
        }
      })
      .addCase(removeMake.fulfilled, (state, action) => {
        const makeId = action.payload;
        console.log(action.payload)

        state.makes = state.makes.filter((make) => make.id !== makeId);
      });
  },
});

export const makesActions = makesSlice.actions;

export default makesSlice;
